<template>
	<div class="like-dislike">
		<div class="row row-center">
		    <div class="bottom-button button-like row" @click="vote(1)" :style="{'background-color': mColor(10), color: item.vote_info==1 ? mColor(4) : mColor(3) }">
	            <sui-icon :fill="item.vote_info==1 ? mColor(4) : mColor(2.1)" class="ig--icon" name="arrow-dropup"></sui-icon>
	            <div class="like-text no-flex">赞同</div>
	            <div class="like-num no-flex" v-text="item.approval_num"></div>
	        </div>

	        <div class="bottom-button button-dislike" @click="vote(2, )" :style="{'background': mColor(10), color: item.vote_info==1 ? mColor(4) : mColor(3) }">
	            <sui-icon :fill="item.vote_info==2 ? mColor(4) : mColor(2.1)" class="ig--icon" name="arrow-dropdown"></sui-icon>
	        </div>

            <slot></slot>
		</div>
	</div>
</template>
<script>
import mCore from '../../scripts/mixins/core'
import { requestJsonp } from '../../scripts/request'
export default {
    name: 'igc-like',

    mixins: [mCore],

    data() {
        return {
            busy: false
        }
    },

    props: {
        item: {
            type: Object,
            required: true
        }
    },

    methods: {
        vote(operator_type) {
            let that = this
            let item = this.item;
        	if(item.vote_info) {
        		let obj = {
        			1: '赞同',
        			2: '反对'
        		}
        		this.$toast(`您已经${obj[item.vote_info]}过了`);
        		return;
        	}

            if (this.busy) {
                return;
            }

            this.busy = true;

            requestJsonp({
                url: '/interactcenter/add_tiny_guide_vote.php',
                data: {
                    operator_type,
                    guide_id: that.item.guide_id
                }
            }).then(result => {
                if (result.status.toLowerCase() == 'success') {
                    if (operator_type == 1) {
                        item.approval_num = item.approval_num + 1;
                        item.vote_info = 1;
                        that.$toast('点赞成功');
                    } else {
                        item.opposition_num = item.opposition_num + 1;
                        item.vote_info = 2;
                        that.$toast('反对成功');
                    }
                }
                that.$nextTick(()=>{
                    that.busy = false;
                })
            })
        }
    },
    components: {
    }
}
</script>
<style lang="postcss">
.like-dislike {
    .bottom-button {
        padding: 0 20px;
        border-radius: 3px;
        font-size: 22px;
        flex: none;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 42px;
        box-sizing: border-box;
        .ig--icon {
            flex: none;
            width: 24px;
        }
        .like-num {
            margin-left: 7px;
        }
    }
    .button-like {
        /* margin-left: 75px; */
        width: 160px;
        height: 42px;
        margin-right: 16px;
        .ig--icon {
            margin-right: 6px;
        }
    }
    .button-dislike {
        width:60px;
        height: 42px;
        font-size: 22px;
    }
}
</style>